import { register } from "async-ops";
import { callMvcApi } from "../../../../../call-web-api";
import { getDefaultOptions } from "../../../../../utils/fetch";
export const GET_CASE_DATA = "GET_CASE_DATA";

export const service = async (caseId) => {
  const options: object = {
    url: '/Api/ExternalAudit/GetCaseDataTabData',
    method: "POST",
    body: JSON.stringify(caseId),
    ...getDefaultOptions(),
  };
  const response = callMvcApi(options);
  return response;
};

const mockData = () => {
  return [];
};

const mock = () => {
  const promise = new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(mockData());
    }, 2000);
  });
  return promise;
};

register(GET_CASE_DATA, service, mock);
